import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA0GPQZuJqkkveZjrmHTqezyql1sj1fQnI",
  authDomain: "egoist-journal.firebaseapp.com",
  projectId: "egoist-journal",
  storageBucket: "egoist-journal.firebasestorage.app",
  messagingSenderId: "580840434028",
  appId: "1:580840434028:web:ab9640436b3d2041bdab49"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;